<template>
    <div class="server-errors single-page">
        <div class="container-xxl">
            <div class="content p-3 d-flex justify-content-center align-items-center flex-column">
                <img src="/assets/img/error/server-error.png" alt="">
                <h1>SUNUCU HATASI</h1>
                <p>{{ msg }}</p>
                <a :href="Links.Url(Links.Dashboard)" class="btn btn-primary btn-lg py-2 px-2">Anasayfa</a>

                <!--<div style="margin-top:1rem;min-width:500px;">
                    <h2 style="margin-bottom: 0.5rem;">Hata Kayıtları</h2>
                    <button class="btn btn-primary" style="margin-right: 1rem; padding:0.25rem 1rem;" @click="refresh">Yenile</button>
                    <button class="btn btn-primary" style="margin-right: 1rem; padding:0.25rem 1rem;" @click="clearAll">Temizle</button>
                    <pre style="white-space:pre-wrap">{{ errors.length }} kayıt</pre>
                    <ul>
                        <li v-for="r in errors" :key="r.id" style="margin-bottom: 12px;">
                            <strong>{{ r.timestamp }}</strong> — <em>{{ r.source }}</em><br />
                            <small>view: {{ r.view.name || r.view.path }} — component: {{ r.component.name || r.component.info }}</small>
                            <div style="margin-top:6px;background:#f8f8f8;padding:8px;border-radius:4px;">
                                <div><b>msg:</b> {{ r.message }}</div>
                                <details>
                                    <summary>Stack / Extra</summary>
                                    <pre style="white-space:pre-wrap">{{ r.stack || JSON.stringify(r.extra, null, 2) }}</pre>
                                </details>
                            </div>
                        </li>
                    </ul>
                </div>-->
            </div>            
        </div>
    </div>
</template>
<style scoped>
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    .d-flex {
        display: flex !important;
    }

    .flex-column {
        flex-direction: column !important;
    }

    .justify-content-center {
        justify-content: center !important;
    }

    .align-items-center {
        align-items: center !important;
    }

    .p-3 {
        padding: 1rem !important;
    }

    .py-2 {
        padding-top: 0.5rem !important;
        padding-bottom: 0.5rem !important;
    }

    .px-2 {
        padding-right: 0.5rem !important;
        padding-left: 0.5rem !important;
    }

    .btn {
        -webkit-user-select: none;
        -moz-user-select: none;
        user-select: none;
        --bs-btn-padding-x: 0.75rem;
        --bs-btn-padding-y: 0.375rem;
        --bs-btn-font-family:;
        --bs-btn-font-size: 1rem;
        --bs-btn-font-weight: 400;
        --bs-btn-line-height: 1.5;
        --bs-btn-color: #212529;
        --bs-btn-bg: transparent;
        --bs-btn-border-width: 1px;
        --bs-btn-border-color: transparent;
        --bs-btn-border-radius: 12px;
        --bs-btn-hover-border-color: transparent;
        --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
        --bs-btn-disabled-opacity: 0.65;
        --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
        display: inline-block;
        padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
        font-family: var(--bs-btn-font-family);
        font-size: var(--bs-btn-font-size);
        font-weight: var(--bs-btn-font-weight);
        line-height: var(--bs-btn-line-height);
        color: var(--bs-btn-color);
        text-align: center;
        text-decoration: none;
        vertical-align: middle;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        user-select: none;
        border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
        border-radius: var(--bs-btn-border-radius);
        background-color: var(--bs-btn-bg);
        transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }

    a {
        text-decoration: none;
    }

    p {
        margin-top: 0;
        margin-bottom: 1rem;
    }

    .btn.btn-lg, .btn-group-lg > .btn {
        /* width: 267px !important; */
        min-width: 200px !important;
        height: 48px !important;
        border-radius: 12px !important;
    }

    .btn-primary {
        background-color: #A35FC1;
        color: #FFF;
        border-color: #A35FC1;
        border-radius: 12px !important;
        font-weight: 500;
        font-size: 16px !important;
    }

    .container, .container-fluid, .container-xxl, .container-xl, .container-lg, .container-md, .container-sm {
        --bs-gutter-x: 1.5rem;
        --bs-gutter-y: 0;
        width: 100%;
        padding-right: calc(var(--bs-gutter-x) * 0.5);
        padding-left: calc(var(--bs-gutter-x) * 0.5);
        margin-right: auto;
        margin-left: auto;
    }

    .single-page {
        width: 100%;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        overflow-y: auto;
        background: #f7f8fd;
    }

        .single-page .content {
            border-radius: 32px;
            box-shadow: 0 18px 28px 0 rgba(9, 30, 66, 0.04);
            background: #fff !important;
            z-index: 22;
            position: relative;
        }

        .single-page.server-errors img, .single-page .not-found img {
            margin-bottom: 3.5rem;
            max-width: 100%;
            height: auto;
        }

        .single-page.server-errors h1, .single-page.server-errors .h1, .single-page .not-found h1, .single-page .not-found .h1 {
            font-weight: 500;
            font-size: 1.5rem;
            line-height: 29px;
            text-align: center;
            color: #636363;
            margin-bottom: 1rem;
        }

    .single-page .content .btn-primary {
        font-weight: 600;
        color: #fdf9fe;
        margin-bottom: 1.25rem;
        box-shadow: none;
    }
</style>
<script>
    import { getErrors, clearErrors } from "@/helpers/logger";

    export default {
        name: "PageError",
        props: {
            page: String,
            msg: String,
        },
        data() {
            return {
                errors: []
            };
        },
        mounted() {
            this.refresh();
        },
        methods: {
            refresh() {
                this.errors = getErrors();
            },
            clearAll() {
                clearErrors();
                this.refresh();
            }
        }
    };
</script>
